import { render, staticRenderFns } from "./ThankYouForSubmittingView.vue?vue&type=template&id=394a3114&scoped=true&"
import script from "./ThankYouForSubmittingView.vue?vue&type=script&lang=js&"
export * from "./ThankYouForSubmittingView.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouForSubmittingView.vue?vue&type=style&index=0&id=394a3114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a3114",
  null
  
)

/* custom blocks */
import block0 from "./ThankYouForSubmittingView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
